import React from "react";
import {
  InputNumber as AntdInputNumber,
  InputNumberProps as AntdInputNumberProps,
  Typography,
} from "antd";
import { v4 as uuid } from "uuid";

export type InputNumberProps = AntdInputNumberProps & {
  label?: string;
  description?: string;
};

const InputNumber = (props: InputNumberProps) => {
  const identifier = props.id
    ? props.id
    : `accessible-antd-input-number-${uuid()}`;

  return (
    <div>
      {props?.label ? (
        <label htmlFor={identifier}>
          <Typography.Text strong style={{ marginBottom: "8px" }}>
            {props?.label}
          </Typography.Text>
        </label>
      ) : null}
      {props?.description ? (
        <p
          id={`description-${identifier}`}
          style={{ fontSize: "12px", marginBottom: "8px" }}
        >
          {props?.description}
        </p>
      ) : null}
      <AntdInputNumber
        aria-describedby={`description-${identifier}`}
        aria-labelledby={identifier}
        id={identifier}
        {...props}
      />
    </div>
  );
};

export default InputNumber;
